import t from "react";
import { SwipeRightTransition as l } from "../../../animations/transitions/SwipeRightTransition/SwipeRightTransition.js";
import { useAuth as u } from "../../../auth/hooks/useAuth.js";
import { RouteMenu as s } from "./components/RouteMenu/RouteMenu.js";
import { useNavigation as g } from "./hooks/useNavigation.js";
import { RequiresLoginPage as c } from "./pages/RequiresLoginPage/RequiresLoginPage.js";
function x() {
  var i, r;
  const o = g(), {
    customer: e
  } = u();
  if (o === null)
    return console.error("NavigationOutlet is only available inside a NavigationProvider"), null;
  const {
    isNavigationOpen: a,
    navigationConfig: n,
    routes: m
  } = o;
  return /* @__PURE__ */ t.createElement(
    l,
    {
      in: a,
      style: {
        height: "100%"
      }
    },
    e && /* @__PURE__ */ t.createElement(
      s,
      {
        design: {
          content: {
            textColor: ((i = n.common) == null ? void 0 : i.design.text) ?? "#000",
            backgroundColor: ((r = n.common) == null ? void 0 : r.design.background) ?? "#FFF"
          }
        },
        routes: m
      }
    ),
    !e && /* @__PURE__ */ t.createElement(c, null)
  );
}
export {
  x as NavigationOutlet
};
//# sourceMappingURL=NavigationOutlet.js.map
